import React from 'react';

function AboutPage(){
    return(
        <div className="bg-[#222222] h-screen w-screen">
            <h1>Acerca de Nosotros</h1>
            <p>Esta es la pagina que habla sobre el proyecto</p>
        </div>
    );
}

export default AboutPage;
